
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ReviewsViewTabSectionTopContentSuccessMessage',
  mixins: [respUtility],
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
